import { API6, API7 } from "../baseApi";
let currentOrderController = null;

// 코인리스트 조회
const getCoinList = async () => {
    try {
        const response = await API6.get('list');  
        return response.data;
    } catch (error) {
        return;
    }
};

const getSymbolPrice = async (symbol) => {
    try {
        const response = await API7.get(`user/get_price?symbol=${symbol}`);  
        return response.data;
    } catch (error) {
        return;
    }
};


/**
 * @param type : limit or sell
 */
const postLimitOrder = async (type,params) => {
    if (currentOrderController) {
        currentOrderController.abort();
      }
    
      currentOrderController = new AbortController();
    try {
        const response = await API7.post(`trading/${type}_limit_order?${params}`);  
        return response.data;
    } catch (error) {
        // if (error.name === 'AbortError') {
        //     console.error(`이전 ${type} limit 요청 취소됨`);
        // }
        return error.response.data;
    }
};

/**
 * @param type : limit or sell
 */
const postMarketOrder = async (type,params) => {
    if (currentOrderController) {
        currentOrderController.abort();
      }
    
      currentOrderController = new AbortController();
    try {
        const response = await API7.post(`trading/${type}_market_order?${params}`); 
        return response.data;
    } catch (error) {
        // if (error.name === 'AbortError') {
        //     console.error(`이전 ${type} market 요청 취소됨`);
        // }
        return error.response.data;
    }
};

const getCalculateLiqprice = async (params) => {
    try {
        const response = await API7.get(`trading/liq_price?${params}`);  
        return response.data;
    } catch (error) {
        return;
    }
};

export default {
    getCoinList,
    getSymbolPrice,
    postLimitOrder,
    postMarketOrder,
    getCalculateLiqprice
};
